const features = [
  {
    icon: 'ri-team-line',
    title: 'Family-Owned',
    description: 'Local family business that treats your property like our own'
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Reliable Service',
    description: 'Consistent, dependable work you can count on every time'
  },
  {
    icon: 'ri-tools-line',
    title: 'Experienced Crew',
    description: 'Skilled professionals with years of landscaping expertise'
  },
  {
    icon: 'ri-building-line',
    title: 'Residential & Commercial',
    description: 'Comprehensive services for homes and businesses alike'
  },
  {
    icon: 'ri-time-line',
    title: 'Fast Response Times',
    description: 'Quick quotes and prompt service when you need us'
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Customer Focused',
    description: 'Building long-term relationships through quality work'
  }
];

export function WhyChooseUs() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose Greener Eco Landscaping
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We're committed to delivering exceptional landscaping services with integrity and professionalism
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="text-center group cursor-pointer"
            >
              <div className="w-20 h-20 bg-[#4A7C2C] rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <i className={`${feature.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button 
            onClick={scrollToContact}
            className="inline-flex items-center gap-2 bg-[#4A7C2C] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#2D5016] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Request a Quote
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
